import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
	selector: '[appMailList]',
	standalone: true,
	providers: [
		{
			provide: NG_VALIDATORS,
			useExisting: MailListValidatorDirective,
			multi: true,
		},
	],
})
export class MailListValidatorDirective implements Validator {
	private readonly emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;

	validate(control: AbstractControl): ValidationErrors | null {
		const raw = (control.value ?? '') as string;
		const value = raw.trim();

		if (value.length === 0) return null;

		if (value.includes(',') && !value.includes(', ')) {
			return { mailListSeparator: true };
		}

		const parts = value.split(', ');

		if (parts.some((p) => p.trim().length === 0)) {
			return { mailListSeparator: true };
		}

		const invalidEmails = parts.filter((p) => !this.emailRegex.test(p));

		if (invalidEmails.length > 0) {
			return {
				mailListEmail: {
					invalid: invalidEmails,
				},
			};
		}

		return null;
	}
}
